import React from "react";
import AuthPage from "./AuthPage";

export default function LoginPage() {
    return <AuthPage mode="login" />;
}
